import { render, staticRenderFns } from "./distances.vue?vue&type=template&id=21cf7116"
import script from "./distances.vue?vue&type=script&lang=js"
export * from "./distances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports